const concurrent_device_limit = {
    title: 'محدودیت دستگاه همزمان',
    enable: 'فعال‌سازی محدودیت دستگاه همزمان',
    enable_description: 'وقتی فعال باشد، Logto حداکثر مجوزهای فعال به ازای هر کاربر را برای این برنامه اعمال می‌کند.',
    field: 'محدودیت دستگاه همزمان به ازای هر برنامه',
    field_description: 'تعداد دستگاه‌هایی که یک کاربر می‌تواند به طور همزمان وارد آن‌ها شده باشد را محدود کنید. Logto این کار را با محدود کردن مجوزهای فعال انجام می‌دهد و هنگامی که محدودیت از حد تجاوز کند، قدیمی‌ترین مجوز را به طور خودکار لغو می‌کند.',
    field_placeholder: 'برای بدون محدودیت خالی بگذارید',
    should_be_greater_than_zero: 'باید بزرگ‌تر از ۰ باشد.',
};
export default Object.freeze(concurrent_device_limit);
